/**
 *Created by jmmartinez on 13/8/18
 *
 * v.1.1 05/03/2019 Añadido tablaclassName, comboBoxClassName, popoverClassName
 * v.1.2 03/01/2020 Modificado para indicar el númElementos en onNumElementosChanged
 * v.2.0 05/11/2020 Pasado a Framework 2.0
 * v.2.1 20/11/2020 Añadida propiedad onCeldaClick y transimisión a <TablaFlex
 *                  Añadida propiedad elementoSeleccionado
 * v.2.2 12/12/2020 Añadida propiedad onCeldaDobleClick
 **/
import React from 'react'

import PropTypes from 'prop-types';
import TablaFlex from "./TablaFlex"
import '../../resources/css/pagination.css';
import ReactPaginate from 'react-paginate';
import ComboBox from "../../blueprint/ComboBox";
import { Spinner, Intent} from "@blueprintjs/core";

class TablaFlexPaginada extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datos: [],
            numElementosPorPaginaInicial: props.numElementosPorPaginaInicial,
            numElementosPorPaginaItem: {codigo: props.numElementosPorPaginaInicial, valor: props.numElementosPorPaginaInicial},
            numPaginas:props.numPaginas,
            numElementosOpcionesCadena: props.numElementosOpcionesCadena,
            numElementosOpciones: props.numElementosOpcionesCadena ? this.generarNumElementosOpciones(props.numElementosOpcionesCadena) : [],
            offset: 0,
            paginaActual: 0,
            cargandoDatos: false,
        }
        console.log("constructor:");
        console.log(this.state);
        //console.log("opcionesCadena: " + props.numElementosOpcionesCadena);
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if(nextProps.datos !== prevState.datos){
            newState.datos= nextProps.datos;
        }

        if(nextProps.cargandoDatos !== prevState.cargandoDatos){
            newState.cargandoDatos= nextProps.cargandoDatos;
        }

        if(nextProps.numPaginas !== prevState.numPaginas){
            newState.numPaginas= nextProps.numPaginas;
        }

        if(nextProps.numElementosOpcionesCadena !== prevState.numElementosOpcionesCadena){
            newState.numElementosOpcionesCadena= nextProps.numElementosOpcionesCadena;
            newState.numElementosOpciones= this.generarNumElementosOpciones(nextProps.numElementosOpcionesCadena);
        }

        if(nextProps.numElementosPorPaginaInicial !== prevState.numElementosPorPaginaInicial){
            newState.numElementosPorPaginaInicial= nextProps.numElementosPorPaginaInicial;
            newState.numElementosPorPaginaItem= {codigo: nextProps.numElementosPorPaginaInicial, valor: nextProps.numElementosPorPaginaInicial};

        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onPageClick = data => {
        const {numElementosPorPaginaItem} = this.state;
        const {onRefreshData} = this.props;

        let selected = data.selected;
        let offset = Math.ceil(selected * numElementosPorPaginaItem.valor);
        this.setState({ offset : offset, paginaActual: data.selected });
        onRefreshData && onRefreshData(offset, numElementosPorPaginaItem.valor);

    };

    onNumElementosChanged = (item) => {
        const {offset} = this.state;
        const {onRefreshData} = this.props;
        let numElementos= item.codigo;
        this.setState({ numElementosPorPaginaItem : item });
        onRefreshData && onRefreshData(offset, numElementos);

    }

    generarNumElementosOpciones= (numElementosOpcionesCadena) => {
        let numElementosOpcionesArray= numElementosOpcionesCadena.split(",");
        let numElementosOpciones = numElementosOpcionesArray.reduce((numElementosOpcionesReduced, dato) => {
            numElementosOpcionesReduced.push({
                codigo: dato,
                valor: dato,
            });
            return numElementosOpcionesReduced;
        }, []);
        return numElementosOpciones;
    }

    render() {
        const {datos, cargandoDatos, numPaginas,  numElementosOpciones, numElementosPorPaginaItem, paginaActual} =  this.state;
        const {onCeldaClick, onCeldaDobleClick, elementoSeleccionado, numElementosPorPaginaInicial} = this.props;

        let mostrarTabla= datos && datos.length > 0 && !cargandoDatos;
        let mostrarPaginador= numElementosPorPaginaInicial > 0;

        console.log("TABLAFLEXPAGINADA - RENDER");
        console.log("numElementosPorPaginaInicial: ", numElementosPorPaginaInicial);
        console.log("mostrarPaginador: ", mostrarPaginador);


        //console.log("datos:");
        //console.log(datos);
        //console.log("children:");
        //console.log(this.props.children);

        return (
                <div>

                    { cargandoDatos && <Spinner intent={Intent.PRIMARY} size={50} /> }

                    {
                        mostrarTabla &&
                        <TablaFlex datos={datos} onCeldaClick={onCeldaClick} elementoSeleccionado={elementoSeleccionado}
                            onCeldaDobleClick={onCeldaDobleClick} >
                            {this.props.children}
                        </TablaFlex>
                    }

                    {
                        mostrarTabla &&
                        <div className="paginador">
                            {mostrarPaginador &&

                                <ReactPaginate
                                    previousLabel={'anterior'}
                                    nextLabel={'siguiente'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={numPaginas}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.onPageClick}
                                    containerClassName={"pagination"}
                                    pageClassName={"pagination-page"}
                                    previousClassName={"pagination-page"}
                                    nextClassName={"pagination-page"}
                                    activeClassName={"pagination-active"}
                                    pageLinkClassName={"pagination-link"}
                                    forcePage={paginaActual}
                                />
                            }
                            <ComboBox
                                id="cbNumElementos"
                                fieldText="valor"
                                fieldKey="codigo"
                                items={numElementosOpciones}
                                onValueChanged={this.onNumElementosChanged}
                                filterable={false}
                                icon="drag-handle-vertical"
                                itemSelected={numElementosPorPaginaItem}
                                popoverClassName="popover"
                            />
                        </div>

                    }

                </div>

        );
    }
}



TablaFlexPaginada.propTypes = {
    datos: PropTypes.array.isRequired,
    onRefreshData: PropTypes.func,
    onCeldaClick: PropTypes.func,
    onCeldaDobleClick: PropTypes.func,
    elementoSeleccionado: PropTypes.object,
}

export default TablaFlexPaginada
